<template>
    <div class="wrapper">
        <router-link class="back" :to="{name: backLink}">Zurück</router-link>
        <div class="machine-details">
            <div>
                <h3 class="machine-details__title">
                  {{ `${machine.manufacturer.value} ${machine.model}` }}
                </h3>
                <div class="achine-details__image machine-image">
                    <img
                      v-lightbox="`${machine.images[0].href}?width=2000`"
                      class="machine-image__main"
                      :src="machine.images[0].href">
                    <div class="image-thumbs">
                        <img
                          v-lightbox="`${image.href}?width=2000`"
                          class="image-thumbs__image"
                          v-for="(image) in machine.images"
                          :src="`${image.href}?width=400`" :key="image.id">
                    </div>
                </div>
            </div>
            <div>
                <div class="showcase">
                    <showcase-option v-for="(option) in showCaseOptions"
                                     :_id="option.id"
                                     :name="option.name"
                                     :type="option.type"
                                     :value="option.value"
                                     :show="option.show"
                                     :unit="option.unit"
                                     :key="option.id"
                    />
                </div>
                <ul>
                    <li v-for="(option) in machine.options" :key="option.id">
                      {{ `${option.name}: ${option.show}` }}
                    </li>
                </ul>
                <div class="machine__price">
                    <span>{{ machine.price.value | price }}</span>
                    <div v-if="nettoPrice" class="machine__price--netto">
                        <span>{{ nettoPrice  | price }}</span> inkl. {{ machine.vat.value }}% MwSt.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import ShowcaseOption from './ShowcaseOption.vue';

const showCaseOptions = [
  1,
  111,
  353,
];

export default {
  components: {
    ShowcaseOption,
  },
  data() {
    return {};
  },
  computed: {
    nettoPrice() {
      if (this.machine.vat.value === 0) return null;
      return this.machine.price.value * (1 + (this.machine.vat.value / 100));
    },
    machine() {
      return this.$store.getters.getMachines
        // eslint-disable-next-line no-bitwise
        .find((machine) => this.$route.params.id >>> 0 === machine.id);
    },
    backLink() {
      return this.$route.name.split('.')[0];
    },
    showCaseOptions() {
      if (!this.machine.options) return [];
      return this.machine.options.filter((option) => (
        showCaseOptions.includes(option.id)
      ));
    },
  },
  filters: {
    price(value) {
      if (value === 0) return 'Preis auf Anfrage';
      return value.toLocaleString('de-DE', {
        maximumSignificantDigits: 3,
        style: 'currency',
        currency: 'EUR',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
    .wrapper {
        padding: 1em;
    }
    .back {
        /*border: solid 2px;*/
        border-radius: 0 0 12px 0;
        text-decoration: none;
        padding: .75em;
        margin: -1em -1em 1em;
        display: table;
        /*margin: auto;*/
        font-weight: 500;
        text-align: center;
        background: linear-gradient(to right, var(--gradient-color-1), var(--gradient-color-2));
        color: #fff;
    }
    .showcase {
        display: flex;
        justify-content: space-around;
        margin: 1em;
    }
    .machine {
        &__price {
            font-size: 2em;
            background: linear-gradient(to right, var(--gradient-color-1), var(--gradient-color-2));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-weight: 800;
            text-align: center;
            margin: 1em 0;
            &--netto {
                font-size: .5em;
            }
        }
    }
    .machine-details {
        display: grid;
        grid-template-columns: 40% 1fr;
        &__title {
            font-size: 2.25em;
            margin: .25em 0 .5em 0;
            font-weight: 300;
        }
    }
    .machine-image {
        &__main {
            width: 100%;
        }
    }
    .image-thumbs {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        &__image {
            width: 100%;
        }
    }
</style>
